export const convertToFloat = (value: string | number) => {
    if (typeof value === "string") {
        return parseFloat(value.replace(",", "."));
    }
    return value;
};